import { isAgentEngineAvailable } from "@productlane/lib/src/agent-recommendations"

import { useZeroWorkspace } from "@/lib/zero"

// The daily recommendations engine runs for early-access and new workspaces.
export function useIsAgentEngineAvailable(): boolean {
	const workspace = useZeroWorkspace()
	return isAgentEngineAvailable(workspace?.id, {
		isDevelopment: import.meta.env.DEV,
		createdAt: workspace?.createdAt,
	})
}
